import type { ComponentType, FC } from 'react'

import {
  browserTracingIntegration,
  getClient,
  init,
  makeBrowserOfflineTransport,
  replayIntegration,
} from '@sentry/react'
import { env } from 'common/utils/env'

const sentryOfflineTransport = makeBrowserOfflineTransport()

export const withSentry = <T extends object>(Component: ComponentType<T>): FC<T> => {
  if (env.SENTRY_DSN) {
    init({
      dsn: env.SENTRY_DSN,
      environment: env.ENV,
      integrations: [browserTracingIntegration(), replayIntegration()],
      transport: (transportOptions) =>
        sentryOfflineTransport({
          ...transportOptions,
          dbName: 'residen-sentry-offline',
          storeName: 'doctor-app-envelopes',
          maxQueueSize: 30,
          flushAtStartup: true,
        }),
      tracePropagationTargets: ['localhost', /.*residen\.com/],
      tracesSampleRate: 1.0,
      replaysSessionSampleRate: 0.1,
      replaysOnErrorSampleRate: 1.0,
    })

    const client = getClient()
    if (client) {
      console.log(`[Sentry] Initialized (environment: ${env.ENV})`)
    } else {
      console.warn('[Sentry] Failed to initialize')
    }
  } else {
    console.warn('[Sentry] Skipped — VITE_SENTRY_DSN is not set')
  }

  const WithSentryWrapper: FC<T> = (props: T) => {
    return <Component {...props} />
  }

  return WithSentryWrapper
}
